import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15ea0e01"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "PankuzuHeader_MainArea" }
const _hoisted_2 = { class: "PankuzuHeader_List" }
const _hoisted_3 = { class: "PankuzuHeader_PathName" }



interface Props {
  isActive_SidebarFlg: boolean;
  currentPathList: { name: string }[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PankuzuHeader',
  props: {
    isActive_SidebarFlg: { type: Boolean },
    currentPathList: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["PankuzuHeader", {
      SideBar_False: !_ctx.isActive_SidebarFlg,
      SideBar_True: _ctx.isActive_SidebarFlg,
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("ul", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentPathList, (path, index) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "PankuzuHeader_List_Item",
            key: index
          }, [
            _createVNode(_component_font_awesome_icon, {
              icon: "angle-right",
              class: "PankuzuHeader_Icon"
            }),
            _createElementVNode("span", _hoisted_3, _toDisplayString(path.name), 1)
          ]))
        }), 128))
      ])
    ])
  ], 2))
}
}

})